"use client";

import React from "react";

// Styles
import * as S from "./styles";

interface ProgressBarProps {
  value: number;
  max?: number;
  showPercentage?: boolean;
  color?: string;
  backgroundColor?: string;
  height?: string;
  animated?: boolean;
  striped?: boolean;
  className?: string;
  label?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = 100,
  showPercentage = false,
  color = "var(--primary)",
  backgroundColor = "var(--primarySystem100)",
  height = "13px",
  animated = false,
  striped = false,
  className,
}) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <S.ProgressContainer className={className}>
      <S.BoxProgressBar $height={height} $backgroundColor={backgroundColor}>
        <S.ProgressFill
          $width={percentage}
          $color={color}
          $animated={animated}
          $striped={striped}
        />
        {showPercentage && (
          <S.ProgressText>{Math.round(percentage)}%</S.ProgressText>
        )}
      </S.BoxProgressBar>
    </S.ProgressContainer>
  );
};

export default ProgressBar;
